import { TripWithDetailsResponse } from '@/shared/api'
import { PageMeta } from './PageMeta'

const DEFAULT_DESCRIPTION = 'View this overlanding trip on SitRepp.io'

interface ShareLinkMetaProps {
  trip: TripWithDetailsResponse
  shareToken: string
}

/**
 * Sets document title and Open Graph / Twitter Card meta for trip share links.
 * Enables rich previews when sharing /share/:token links on social media and messaging.
 */
export function ShareLinkMeta({ trip, shareToken }: ShareLinkMetaProps) {
  const title = trip.name || 'SitRepp Trip'
  const description = trip.description || DEFAULT_DESCRIPTION
  const ogUrl = typeof window !== 'undefined' ? `${window.location.origin}/share/${shareToken}` : undefined

  return (
    <PageMeta
      title={title}
      description={description}
      ogUrl={ogUrl}
    />
  )
}
